<template>
  <div class="no-header">
    <v-img aspect-ratio="2"
           :src="require('../assets/BeCool-Logo-trackpage.png')"
           gradient="315deg, rgba(17, 201, 247, .40), rgba(69, 150, 196, .51) 49%, rgba(40,92,205,0.45) "
    >
      <v-container container--fluid grid-list-lg style="min-height:100vh;">
        &nbsp
        <v-row justify="center">
          <v-col cols="12" class="text-center">
            <img :src="clientLogo" :class="centerImage">
          </v-col>
        </v-row>
        &nbsp
        <br>

        <v-container>
          <v-row justify="center" align="center">
            <h1 class="responsive-title">TRACK YOUR DELIVERY</h1>
          </v-row>

          <v-row justify="center" align="center" my-6>
            <v-col xl="4" lg="4" md="4" sm="10">
              <v-text-field
                block
                v-model="tracking"
                placeholder="Tracking Number"
                v-on:keyup.enter="trackDelivery"
              >
              </v-text-field>
            </v-col>

          </v-row>

          <v-row justify="center" align="center" class="mb-6">
            <v-col xl="4" lg="4" md="4" sm="10">
              <v-btn
                block
                raised
                dark
                large
                color="indigo"
                @click="trackDelivery"
              >
                Track It !
              </v-btn>
            </v-col>
          </v-row>

          <v-alert prominent :value="trackNotFound" type="warning" color="blue">Sorry we could not find this tracking
            number
          </v-alert>

        </v-container>

        <div v-if="searching" style="width: 100%">
          <v-progress-linear
            :indeterminate="true"
          ></v-progress-linear>
        </div>


        <v-row justify="space-around" align="center">
          <v-col lg="12" cols="12">
            <v-container container--fluid grid-list-xl>
              <v-row justify="space-around">
                <v-col cols="12" md="6" lg="6">
                  <transition name="slide-y-transition">
                    <TrackPageInfo
                      v-if="infoSeen"
                      :show-map="showMap"
                      :time="time"
                      :tracking-info="trackingInfo"
                      :geocode="geocode"
                      :time-field="timeField"
                      :font-style="fontStyle"
                      :font-style-header="fontStyleHeader"
                      :show-driver-circle="showDriverCircle"
                      :is-mobile="isMobile"
                    ></TrackPageInfo>
                  </transition>
                </v-col>

                <v-col cols="12" md="6" lg="6">
                  <transition name="slide-y-transition">
                    <v-card class="mb-6" v-if="infoSeen && pod !== null"
                            :class="{'pt-1 elevation-0': isMobile, 'pt-1 elevation-1': !isMobile}">
                      <v-card-title class="justify-center">
                        <h2>Proof Of Delivery</h2>
                      </v-card-title>
                      <v-divider color="#42A5F5"></v-divider>

                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col v-for="(image, index) in pod" :key="index" cols="12">
                            <v-img class="delivery-image" :src="image.url" :aspect-ratio="1"></v-img>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </transition>

                  <transition name="slide-y-transition">
                    <v-card v-if="infoSeen"
                            :class="{'pt-1 mb-6 elevation-0': isMobile, 'pt-1 mb-6 elevation-1': !isMobile}">
                      <v-img :aspect-ratio="296/146"
                             :max-height="146"
                             contain
                             class="image"
                             src="https://www.becoolrefrigeratedcouriers.com.au/wp-content/uploads/2016/04/blue-delivery2.jpg"
                      >
                      </v-img>
                      <v-card-title class="justify-center">
                        <h2>Rate Your Driver</h2>
                      </v-card-title>

                      <v-divider color="#42A5F5"></v-divider>
                      <v-row justify="center" align="center">
                        <v-rating
                          v-model="rating"
                          dark
                          background-color="blue"
                          color="blue"
                          @input="postRating"
                          hover
                          large
                        >
                        </v-rating>
                        <v-alert :value="ratingError" color="#c4e3f1">
                          <v-icon large>warning</v-icon>
                          Sorry an error occurred with the rating of your delivery
                        </v-alert>
                      </v-row>



                        <v-dialog class="align-center" :value="hasRatedGood" width="600px">
                          <v-card>
                            <v-card-title class="text-center justify-center" style="word-break: normal;">
                              <h3>Thank you for your feedback !</h3>
                            </v-card-title>
                            <v-card-text class="pt-4">
                              <img :src="becoolLogo" class="centerImageXS">
                            </v-card-text>
                            <v-card-actions class="justify-center">
                              <v-btn text color="blue darken-1" @click="hasRatedGood=false; ">
                                close
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>


                        <v-row justify="center">
                          <v-col cols="10">
                            <v-dialog :value="hasRatedBad" width="500px">
                              <v-card>
                                <v-card-title>
                                  <h3 class="text-center" style="word-break: normal;">Could you explain us how we could
                                    improve our services ?</h3>
                                </v-card-title>
                                <v-card-text>
                                  <v-textarea counter="100">
                                  </v-textarea>
                                </v-card-text>

                                <v-card-actions class="justify-center">
                                  <v-btn text color="blue darken-1" @click="hasRatedGood=true; hasRatedBad=false">
                                    Send your feedback
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                        </v-row>

                    </v-card>

                  </transition>

                  <transition name="slide-y-transition" v-if="infoSeen && (email !== null || phone_number !== null)">
                    <v-card :class="{'pt-1 elevation-0': isMobile, 'pt-1 elevation-1': !isMobile}">
                      <v-card-title class="justify-center">
                        <h2>Contact</h2>
                      </v-card-title>
                      <v-divider color="#42A5F5"></v-divider>
                      <v-row no-gutter>
                        <v-col cols="12" class="text-center">
                          <v-container>
                            <div class="justify-center">
                             <div class="mb-4">Any issues or queries regarding your delivery ?</div>
                              <div class="raleway-bold mb-2"> HelloFresh customer care</div>

                              <div v-if="phone_number !== null && email !== null">
                                <div class="my-2">
                                  <v-icon color="cyan accent-4" class="mr-4">phone</v-icon>
                                  <a :href="'tel:' + phone_number">{{phone_number}}</a>
                                </div>

                                <div class="my-2">
                                  <v-icon color="blue darken-1" class="mr-4">fas fa-envelope</v-icon>
                                  <a :href="'mailto:' + email">{{email}}</a>
                                </div>

                              </div>

                              <div v-if="phone_number !== null && email === null">
                                <v-icon color="blue" class="mr-4">fas fa-phone-alt</v-icon>
                                <a :href="'tel:' + phone_number">{{phone_number}}</a>
                              </div>

                              <div v-if="phone_number === null && email !== null">
                                <v-icon color="blue darken-1" class="mr-4">fas fa-envelope</v-icon>
                                <a :href="'mailto:' + email">{{email}}</a>
                              </div>

                            </div>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-card>
                  </transition>

                </v-col>

              </v-row>
            </v-container>
          </v-col>

        </v-row>
      </v-container>


      <!--             <v-row>-->
      <!--                  <div id="animated_truck">-->
      <!--                    <div class="text-center">-->
      <!--                      Track Your Box-->
      <!--                      <v-icon>fas fa-truck</v-icon>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--             </v-row>-->

    </v-img>
  </div>
</template>

<script>
    import axios from 'axios'
    import TrackPageInfo from "./util/TrackPageInfo";

    export default {
        name: "TrackingPage",
        components: {TrackPageInfo},
        data() {
            return {
                tracking: '',
                trackingInfo: null,
                geocode: null,
                driver_center: null,
                driver_radius: 0,
                infoSeen: false,
                isMobile: false,
                searching: false,
                time: null,
                timeField: '',
                showMap: true,
                showDriverCircle: true,
                trackNotFound: false,
                rating: null,
                ratingError: false,
                hasRatedGood: false,
                hasRatedBad: false,
                deliverySteps: [
                    {name: 'Depot', color: 'pink', icon: 'fas fa-warehouse', show: true},
                    {name: 'Shipping', color: 'teal lighten-3', icon: 'fas fa-truck', show: true},
                    {name: 'Our drivers are coming to you', color: 'purple', icon: 'fas fa-people-carry', show: true},
                    {name: 'Your box(es) have been delivered', color: 'green', icon: 'fas fa-box-open', show: false},
                ],
                clientLogo: "http://bcrc.io/logo.png",
                becoolLogo: "http://bcrc.io/logo.png",
                email: null,
                phone_number: null,
                pod: null,

            }
        },
        methods: {
            getClientInfo(response) {
                if (response.logo !== null && response.logo !== undefined && response.logo !== '') {
                    this.clientLogo = response.logo;
                }
                if (response.contact_email !== null && response.contact_email !== undefined && response.contact_email !== '') {
                    this.email = response.contact_email;
                }
                if (response.contact_phone !== null && response.contact_phone !== undefined && response.contact_phone !== '') {
                    this.phone_number = response.contact_phone;
                }
            },

            getRating() {
                axios.get(process.env.API_URL + '/tracking/' + this.tracking + '/deliveryrating')
                    .then((response) => {
                        if (response.status === 200) {
                            this.rating = response.data.value;
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 404) {

                        } else {
                            this.ratingError = true;
                        }
                    })
            },

            postRating() {
                this.hasRatedBad = false;
                this.hasRatedGood = false;

                axios({
                    method: 'post',
                    url: process.env.API_URL + '/tracking/' + this.tracking + '/deliveryrating',
                    headers: {},
                    data: {value: this.rating}
                })
                    .then((response) => {
                        if (response.status === 200) {
                            if (this.rating >= 3) {
                                this.hasRatedGood = true;
                            } else {
                                this.hasRatedBad = true;
                            }
                        } else {
                            this.ratingError = true;
                        }
                    })
                    .catch((error) => {
                        if (error.status === 404) {

                        } else {
                            this.ratingError = true;
                        }
                    })
            },
            trackDelivery() {
                this.hasRatedGood = false;
                this.hasRatedBad = false;
                this.ratingError = false;
                this.showDriverCircle = true;
                this.searching = true;
                this.geocode = null;
                this.driver_center = null;
                this.infoSeen = false;
                this.trackNotFound = false;
                this.deliverySteps[3].show = false;
                this.pod = null;
                axios.get(process.env.API_URL + '/tracking/' + this.tracking)
                    .then((response) => {
                        this.getRating();
                        this.infoSeen = true;
                        this.searching = false;
                        this.trackingInfo = response.data;

                        if (response.data.status === "Delivered" || response.data.status === "Processed") {
                            // Delivered Delivery
                            if (response.data.transaction_location !== null) {
                                this.geocode = {
                                    lat: response.data.transaction_location.latitude,
                                    lng: response.data.transaction_location.longitude
                                };
                                this.getClientInfo(response.data);
                                this.deliverySteps[3].show = true;
                                this.showMap = true;
                            } else {
                                this.geocode = null;
                                this.showMap = false;
                            }
                            this.timeField = 'Delivery Time:';
                            this.time = this.trackingInfo.transaction_time.split(' ')[1];
                            this.trackNotFound = false;

                            if (response.data.images.length > 0) {
                                this.pod = response.data.images;
                            }

                        } else {
                            // Pending Delivery
                            if (response.data.site_location !== null) {
                                this.geocode = {
                                    lat: response.data.site_location.latitude,
                                    lng: response.data.site_location.longitude
                                };
                            } else {
                                this.showMap = false;
                                this.geocode = null;
                            }
                            this.timeField = 'Estimated Time:';
                            this.time = this.trackingInfo.estimated_time;
                            this.deliverySteps[3].show = false;
                            if (response.data.vehicle_location !== null) {
                                this.showDriverCircle = true;
                                this.driver_center = {
                                    lat: this.trackingInfo.vehicle_location.vehicle_latitude,
                                    lng: this.trackingInfo.vehicle_location.vehicle_longitude
                                };
                                this.driver_radius = this.trackingInfo.vehicle_location.vehicle_location_radius;
                            } else {
                                this.showDriverCircle = false;
                            }
                            this.trackNotFound = false;
                        }
                    })

                    .catch((error) => {
                        this.searching = false;
                        this.trackNotFound = true;
                    })

            },
        },

        mounted() {
            if (this.$route.query.tracking !== null && this.$route.query.tracking !== undefined) {
                this.tracking = this.$route.query.tracking;
                this.trackDelivery();
            }

            this.isMobile = window.innerWidth < 600;
        },

        computed: {
            fontStyle() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return 'font-size: 1em; align-items: flex-end; text-align: center';
                    case 'md':
                        return 'font-size: 1em; align-items: flex-end; text-align: right';
                    case 'lg':
                        return 'font-size: 1em; align-items: flex-end; text-align: right';
                }
            },

            imageSize() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return '60';
                    case 'sm':
                        return '80';
                    case 'md':
                        return '100';
                    case 'lg':
                        return '120';
                    case 'xl':
                        return '160';
                }
            },

            centerImage() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return 'centerImageXS';
                    case 'sm':
                        return 'centerImageXL';
                }
            }
        }

    }
</script>

<style scoped>

  @media only screen and (max-width: 1500px) {

    .responsive-title {
      font-size: 30px; /* old */
      font-size: 3.0vm; /* IE9 */
      font-size: 3vw;
    }
  }

  @media only screen and (max-width: 1000px) {

    .responsive-title {
      font-size: 45px; /* old */
      font-size: 4.5vm; /* IE9 */
      font-size: 4.5vw;
    }
  }

  @media only screen and (max-width: 750px) {

    .responsive-title {
      font-size: 52px; /* old */
      font-size: 5.2vm; /* IE9 */
      font-size: 5.2vw;
    }
  }

  @media only screen and (max-width: 500px) {

    .responsive-title {
      font-size: 70px; /* old */
      font-size: 7vm; /* IE9 */
      font-size: 7vw;
    }
  }


  #animated_truck {
    margin-right: 20px;
    margin-bottom: 10px;
    width: 120px;
    height: 40px;
    -webkit-animation: animated_truck 5s linear 3s infinite running;
    position: relative;
  }

  @keyframes animated_truck {
    0% {
      left: 0%;
      transform: rotate(0deg);
    }

    5% {
      left: 5%;
      transform: rotate(0deg);
    }

    10% {
      left: 10%;
      transform: rotate(0deg);
    }

    15% {
      left: 15%;
      transform: rotate(0deg);
    }

    20% {
      left: 20%;
      transform: rotate(0deg);
    }

    25% {
      left: 25%;
      transform: rotate(0deg);
    }

    30% {
      left: 30%;
      transform: rotate(0deg);
    }

    35% {
      left: 35%;
      transform: rotate(0deg);
    }

    40% {
      left: 40%;
      transform: rotate(0deg);
    }

    45% {
      left: 45%;
      transform: rotate(0deg);
    }

    50% {
      left: 50%;
      transform: rotate(0deg);
    }

    55% {
      left: 55%;
      transform: rotate(0deg);
    }

    60% {
      left: 60%;
      transform: rotate(0deg);
    }

    65% {
      left: 65%;
      transform: rotate(0deg);
    }

    70% {
      left: 70%;
      transform: rotate(0deg);
    }

    75% {
      left: 75%;
      transform: rotate(0deg);
    }

    80% {
      left: 80%;
      transform: rotate(0deg);
    }

    85% {
      left: 85%;
      transform: rotate(0deg);
    }

    95% {
      left: 95%;
      transform: rotate(0deg);
    }

    100% {
      left: 0%;
      transform: rotate(-360deg);
    }
  }


  #animated_truck2 {
    padding-top: 7px;
    width: 68px;
    height: 40px;
    -webkit-animation: animated_truck2 8s infinite;
    position: relative;
  }

  @keyframes animated_truck2 {
    0% {
      top: 10%;
      right: 100%;
      transform: rotate(90deg);
    }

    5% {
      top: 10%;
      right: 100%;

      transform: rotate(90deg);
    }

    10% {
      top: 10%;
      right: 100%;

      transform: rotate(90deg);
    }

    15% {
      top: 20%;
      right: 100%;

      transform: rotate(90deg);
    }

    20% {
      top: 20%;
      right: 100%;

      transform: rotate(90deg);
    }

    25% {
      top: 30%;
      right: 100%;

      transform: rotate(90deg);
    }

    30% {
      top: 30%;
      right: 100%;

      transform: rotate(90deg);
    }

    35% {
      top: 40%;
      right: 100%;

      transform: rotate(90deg);
    }

    40% {
      top: 40%;
      right: 100%;

      transform: rotate(90deg);
    }

    45% {
      top: 50%;
      right: 100%;

      transform: rotate(90deg);
    }

    50% {
      top: 50%;
      right: 100%;

      transform: rotate(90deg);
    }

    55% {
      top: 60%;
      right: 100%;

      transform: rotate(90deg);
    }

    60% {
      top: 60%;
      right: 100%;

      transform: rotate(90deg);
    }

    65% {
      top: 70%;
      right: 100%;

      transform: rotate(90deg);
    }

    70% {
      top: 70%;
      right: 100%;

      transform: rotate(90deg);
    }

    75% {
      top: 80%;
      right: 100%;

      transform: rotate(90deg);
    }

    80% {
      top: 80%;
      right: 100%;

      transform: rotate(90deg);
    }

    85% {
      top: 90%;
      right: 100%;

      transform: rotate(90deg);
    }

    100% {
      top: 10%;
      right: 100%;

      transform: rotate(+450deg);
    }

  }

  .centerImageXS {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 30%;
  }

  .centerImageXL {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 30%;
  }

  .no-header {
    margin-top: 0 !important;
  }

  .delivery-image {
    max-height: 80vh;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/TrackingPage.vue